import apiConfig from '../apiConfig'

export const deleteService = async (at, serviceid) => {
    const response = await apiConfig.post(
        '/API/ADMINISTRATION/SERVICES/DEL_SERVICE',
        {
            Service_Id: serviceid
        },
        {
            headers: {
                Authorization: `Bearer ${at}`
            }
        }
    )


    if (response.data.Status) {
        return response.data
    }

    return []
}
